import React, { useMemo, useState } from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { GalleryGrid, GalleryImage } from '../components/GalleryGrid';
import { ImageModal } from '../components/ImageModal';
import { motion } from 'framer-motion';
// Mock Data
const allImages: GalleryImage[] = [
// Events
{
  id: 1,
  category: 'Events',
  title: 'Live DJ Set',
  src: 'https://cdn.magicpatterns.com/uploads/fwgdVVWY6w4ZNzLwaN8pQF/SnapInsta.to_682684463_18095297435328170_2923975602234658742_n.jpg'
}, {
  id: 2,
  category: 'Events',
  title: 'Crowd Energy',
  src: 'https://cdn.magicpatterns.com/uploads/iyPetroGroUojZdyUQXNKw/SnapInsta.to_684225988_18095297486328170_7779366325725060661_n.jpg'
}, {
  id: 3,
  category: 'Events',
  title: 'Stage Performance',
  src: 'https://cdn.magicpatterns.com/uploads/6VYL7C1UR5Mf2BFZpi16Fi/SnapInsta.to_683810361_18095297495328170_5024856363855259451_n.jpg'
}, {
  id: 4,
  category: 'Events',
  title: 'Nightlife Vibes',
  src: 'https://cdn.magicpatterns.com/uploads/va8WBqwRFPJVrp1Tyd8QNn/SnapInsta.to_684140561_18095297540328170_1227165002793297535_n.jpg'
}, {
  id: 5,
  category: 'Events',
  title: 'Special Guest',
  src: 'https://cdn.magicpatterns.com/uploads/6LnQJuHyfQwVZFXw8tjh5d/SnapInsta.to_683098766_18095297579328170_3814077117280607925_n.jpg'
},
// Venue
{
  id: 6,
  category: 'Venue',
  title: 'Main Lounge',
  src: 'https://cdn.magicpatterns.com/uploads/eSNnVE12Pb6djuzdqREZxv/SnapInsta.to_684815228_18095302001328170_2447475437854116174_n.jpg'
}, {
  id: 7,
  category: 'Venue',
  title: 'VIP Section',
  src: 'https://cdn.magicpatterns.com/uploads/s3K8wKdfybMP1zxoh7PS3W/SnapInsta.to_684049710_18095297510328170_549094879827346722_n.jpg'
}, {
  id: 8,
  category: 'Venue',
  title: 'VIP Celebration',
  src: 'https://cdn.magicpatterns.com/uploads/6VYL7C1UR5Mf2BFZpi16Fi/SnapInsta.to_683810361_18095297495328170_5024856363855259451_n.jpg'
}, {
  id: 9,
  category: 'Venue',
  title: 'Bottle Parade',
  src: 'https://cdn.magicpatterns.com/uploads/fwgdVVWY6w4ZNzLwaN8pQF/SnapInsta.to_682684463_18095297435328170_2923975602234658742_n.jpg'
}, {
  id: 10,
  category: 'Venue',
  title: 'Entrance Hall',
  src: 'https://cdn.magicpatterns.com/uploads/xk9CNNkWNr8YNTct87fWbi/SnapInsta.to_682077530_18095301950328170_9178311643633562905_n.jpg'
},
// Food
{
  id: 11,
  category: 'Food',
  title: 'Main Hall Perspective',
  src: 'https://cdn.magicpatterns.com/uploads/2rjXUfMZfcG9xoKVhqBw5u/HOF_8.jpg'
}, {
  id: 12,
  category: 'Food',
  title: 'Theater of Dreams Neon',
  src: 'https://cdn.magicpatterns.com/uploads/hCM9V9Vkj7KdrVKoueBuWs/HOF_12.jpg'
}, {
  id: 13,
  category: 'Food',
  title: 'Elite Seating Arrangement',
  src: 'https://cdn.magicpatterns.com/uploads/mNTFqmsMdHbfPctSPfK7sR/HOF_18.jpg'
}, {
  id: 14,
  category: 'Food',
  title: 'Dessert Selection',
  src: 'https://images.unsplash.com/photo-1563729784474-d77dbb933a9e?q=80&w=1000&auto=format&fit=crop'
}, {
  id: 15,
  category: 'Food',
  title: 'Premium Drinks',
  src: 'https://images.unsplash.com/photo-1470337458703-46ad1756a187?q=80&w=1000&auto=format&fit=crop'
},
// Nightlife
{
  id: 16,
  category: 'Nightlife',
  title: 'Dance Floor',
  src: 'https://cdn.magicpatterns.com/uploads/ad6jT6urC8DptPHknEKxeE/SnapInsta.to_686901633_17925323268315122_4386797257290448497_n.jpg'
}, {
  id: 17,
  category: 'Nightlife',
  title: 'Moet Celebration',
  src: 'https://cdn.magicpatterns.com/uploads/tpWemGKh6PJ8UBF26GyTiu/SnapInsta.to_683411563_18095297477328170_5374460014215317774_n.jpg'
}, {
  id: 18,
  category: 'Nightlife',
  title: 'Birthday Vibes',
  src: 'https://cdn.magicpatterns.com/uploads/6LnQJuHyfQwVZFXw8tjh5d/SnapInsta.to_683098766_18095297579328170_3814077117280607925_n.jpg'
}, {
  id: 19,
  category: 'Nightlife',
  title: 'VIP Lounge Vibe',
  src: 'https://cdn.magicpatterns.com/uploads/jwoKje4bDvNeyJALbKxqea/HOF_7.jpg'
}, {
  id: 20,
  category: 'Nightlife',
  title: 'Elite Atmosphere',
  src: 'https://cdn.magicpatterns.com/uploads/6p84w61y7K18bvUWzQtAJm/HOF_11.jpg'
}, {
  id: 21,
  category: 'Food',
  title: 'Culinary Excellence',
  src: 'https://cdn.magicpatterns.com/uploads/kuV672Q45N7omdtkaA1srn/The food Yeah… it slaps. 🔥Don’t debate it — experience it.Jollof & Suya that hits every time.Th.mp4',
  type: 'video'
}, {
  id: 22,
  category: 'Nightlife',
  title: 'Elite Entertainment',
  src: 'https://cdn.magicpatterns.com/uploads/wieyszei4i4SLLp24zmkTw/Never a dull night at the Theatre of Dreams.Spring into the weekend with us — beautiful weather,.mp4',
  type: 'video'
}, {
  id: 23,
  category: 'Events',
  title: 'Africa Day Brunch',
  src: 'https://cdn.magicpatterns.com/uploads/gPaCg1KM1zYkh1fbYwJtok/AFRICA DAY BRUNCH WAS ONE FOR THE BOOKS 🔥🌍🥂Great food. Endless mimosas. Amazing energy w-  Mi.mp4',
  type: 'video'
}, {
  id: 24,
  category: 'Nightlife',
  title: 'Laser Lights',
  src: 'https://cdn.magicpatterns.com/uploads/rXCwpc2Nx6ZShu23cqZwyk/SnapInsta.to_682057698_18095297465328170_6663686777263624273_n.jpg',
  type: 'image'
}, {
  id: 25,
  category: 'Events',
  title: 'Theatre Fridays Flyer',
  src: 'https://cdn.magicpatterns.com/uploads/vFoLKQt7tmQNeW42491i3H/Screenshot_2026-06-03_121032.png',
  type: 'image'
}, {
  id: 26,
  category: 'Events',
  title: 'Sunday Brunch Flyer',
  src: 'https://cdn.magicpatterns.com/uploads/1UnSRj778xTSEKhZj3RWW2/Brunch_is_cool.But_brunch_with_music,_energy,_cocktails,_and_your_peopleThat’s_a_lifestyle.All_Y.jpg',
  type: 'image'
}, {
  id: 27,
  category: 'Events',
  title: 'Melodies & Mimosas Fats',
  src: 'https://cdn.magicpatterns.com/uploads/egvtu2RZh7jyk4VrcNfkZs/Screenshot_2026-06-03_121131.png',
  type: 'image'
}, {
  id: 28,
  category: 'Events',
  title: 'Melodies & Mimosas Jay',
  src: 'https://cdn.magicpatterns.com/uploads/5S6yLELAjwmUT7HgMM4TwU/Screenshot_2026-06-03_121150.png',
  type: 'image'
}, {
  id: 29,
  category: 'Events',
  title: 'Rum Punch & Suya',
  src: 'https://cdn.magicpatterns.com/uploads/fDpzvrHSUUb7wem2YitCTV/Stay_tuned_after_Sunday’s_All_You_Can_Eat_Brunch_for_a_special_Mother’s_Day_Edition_of_Rum_Punch.jpg',
  type: 'image'
}, {
  id: 30,
  category: 'Venue',
  title: 'Hero Video',
  src: 'https://cdn.magicpatterns.com/uploads/uDqGHHx2yGqYV665Pa3pjH/hero (1).mp4',
  type: 'video'
}, {
  id: 31,
  category: 'Nightlife',
  title: 'Dream House Tuesdays',
  src: 'https://cdn.magicpatterns.com/uploads/at2R9HfHifzkaQFcUBJR5b/SnapInsta.to_660779906_18095297552328170_5827793037302573987_n.jpg',
  type: 'image'
}, {
  id: 32,
  category: 'Nightlife',
  title: 'Thursday Night Life',
  src: 'https://cdn.magicpatterns.com/uploads/6T3H2WZmmtkMUMZCbd7Kxp/SnapInsta.to_681340710_18095297600328170_3727840379771406033_n.jpg',
  type: 'image'
}, {
  id: 33,
  category: 'Nightlife',
  title: 'Theatre Fridays',
  src: 'https://cdn.magicpatterns.com/uploads/rJSkXauUYeoLtet5juNndy/SnapInsta.to_681279189_18095297528328170_1432439404206680717_n.jpg',
  type: 'image'
}];
const categories = ['All', 'Events', 'Venue', 'Food', 'Nightlife'];
export function Gallery() {
  const [activeCategory, setActiveCategory] = useState<string>('All');
  const [selectedImageIndex, setSelectedImageIndex] = useState<number | null>(null);
  const filteredImages = useMemo(() => activeCategory === 'All' ? allImages : allImages.filter(img => img.category === activeCategory), [activeCategory]);
  const handleNext = () => {
    if (selectedImageIndex === null) return;
    setSelectedImageIndex((selectedImageIndex + 1) % filteredImages.length);
  };
  const handlePrev = () => {
    if (selectedImageIndex === null) return;
    setSelectedImageIndex((selectedImageIndex - 1 + filteredImages.length) % filteredImages.length);
  };
  return <div className="min-h-screen bg-[#0B1014] text-white" data-id="element-1358">
      <Header data-id="element-1359" />
      {/* Hero */}
      <section className="relative pt-32 pb-12 md:pt-40 md:pb-16 px-6 overflow-hidden" data-id="element-1360">
        <div className="absolute inset-0 opacity-10 pointer-events-none" data-id="element-1361">
          <div className="absolute top-10 left-1/4 w-96 h-96 bg-[#DDA247] rounded-full blur-3xl" data-id="element-1362" />
          <div className="absolute bottom-0 right-1/4 w-80 h-80 bg-[#DDA247] rounded-full blur-3xl" data-id="element-1363" />
        </div>
        <div className="container mx-auto relative z-10 text-center" data-id="element-1364">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-1365">
            <p className="text-[#DDA247] text-xs md:text-sm font-bold tracking-[0.3em] uppercase mb-3" data-id="element-1366">
              The Theatre of Dreams
            </p>
            <h1 className="text-4xl md:text-6xl font-black text-white tracking-tight uppercase mb-4" data-id="element-1367">
              Gallery
            </h1>
            <div className="w-16 md:w-24 h-1 bg-[#DDA247] mx-auto mb-5" data-id="element-1368" />
            <p className="text-base md:text-lg text-gray-300 max-w-2xl mx-auto leading-relaxed" data-id="element-1369">
              Step inside House of Flavor. Browse moments from our brunches,
              nightlife, private events, and more.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Category Tabs */}
      <section className="px-6 pb-8 md:pb-10" data-id="element-1370">
        <div className="container mx-auto" data-id="element-1371">
          <div className="flex flex-wrap gap-2 md:gap-3 justify-center" data-id="element-1372">
            {categories.map(cat => {
            const isActive = activeCategory === cat;
            return <button key={cat} onClick={() => setActiveCategory(cat)} className={`px-4 md:px-6 py-2 md:py-2.5 text-xs md:text-sm font-bold uppercase tracking-widest rounded-full border transition-all duration-300 ${isActive ? 'bg-[#DDA247] text-[#0B1014] border-[#DDA247]' : 'bg-transparent text-white border-white/15 hover:border-[#DDA247] hover:text-[#DDA247]'}`} data-id="element-1373">
                  {cat}
                </button>;
          })}
          </div>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="px-6 pb-20 md:pb-24" data-id="element-1374">
        <div className="container mx-auto" data-id="element-1375">
          <GalleryGrid images={filteredImages} onImageClick={index => setSelectedImageIndex(index)} data-id="element-1376" />
        </div>
      </section>

      <Footer data-id="element-1377" />

      {/* Lightbox Modal */}
      <ImageModal isOpen={selectedImageIndex !== null} image={selectedImageIndex !== null ? filteredImages[selectedImageIndex].src : ''} title={selectedImageIndex !== null ? filteredImages[selectedImageIndex].title : ''} category={selectedImageIndex !== null ? filteredImages[selectedImageIndex].category : ''} type={selectedImageIndex !== null ? filteredImages[selectedImageIndex].type : 'image'} currentIndex={selectedImageIndex || 0} totalImages={filteredImages.length} onClose={() => setSelectedImageIndex(null)} onNext={handleNext} onPrev={handlePrev} data-id="element-1378" />
    </div>;
}